import { withViewer } from '../../../external/common/hoc/with-viewer';
import AppRoot from '../../../external/related-posts-widget/containers/app-root';

export default withViewer(AppRoot);
